import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";

type LogoutFailedDialogProps = {
  open: boolean;
  onRetry: () => void;
  onGoToLogin: () => void;
};

export const LogoutFailedDialog = ({
  open,
  onRetry,
  onGoToLogin
}: LogoutFailedDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
      slotProps={{ paper: { sx: { borderRadius: 3 } } }}
    >
      <DialogTitle>{t("logout failed")}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {t("federated logout failed message")}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{ justifyContent: "center", gap: 2, p: 3, flexWrap: "wrap" }}
      >
        <Button size="large" variant="contained" onClick={onRetry}>
          {t("try again")}
        </Button>
        <Button size="large" variant="text" onClick={onGoToLogin}>
          {t("go to login")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
